<template>
  <div v-if="object && object.type == 'textbox'">
    <div class="font_load_container">
      <div v-for="item in fontList" :key="item" :style="'font-family:' + item">.</div>
    </div>
    <el-card>
      <div style="display:flex; justify-content: space-between">
        <div class="borad_con_s">
          <div class="item">
            <b>TEXT</b>
            <el-input style="width:100%" v-model="activeText"> </el-input>
          </div>
          <div class="item">
            <b>FONT FAMILY</b>
            <el-select size="" v-model="activeFontFamily">
              <template v-for="item in fontList">
                <el-option :key="item" :value="item">
                  <div :style="'font-family:' + item + '!important;'">{{ item }}</div>
                </el-option>
              </template>
            </el-select>
          </div>
          <!-- <div class="item">
            <b>字间距</b>
            <el-input style="width:100%" v-model="charSpacing"> </el-input>
          </div> -->
        </div>
      </div>
      <div class="mt20" style="display:flex; justify-content: space-between; align-items:center">
        <ColorListComponent :active="aciveColor" @change="handleSetColor"></ColorListComponent>
        <div class="removeIcon" @click="handleRemove">
          <i style="font-size: 26px" class="el-icon-delete"></i>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import ColorListComponent from '@/components/ColorList.vue';
export default {
  components: {
    ColorListComponent,
  },
  props: ['object'],
  data() {
    return {
      activeText: '',
      activeFontFamily: '',
      charSpacing: '',
      aciveColor: 'rgb(255, 96, 214)',
      fontList: [
        'Aoox',
        'Autoguard',
        'BadScript',
        'BaristaScript',
        'Bath',
        'BEYNO',
        'BreakFill',
        'BukhariScript',
        'Dobby',
        'Fitalia',
        'Garden',
        'LondrinaOutline',
        'LoveloLine',
        'Marske',
        'Megrim',
        'Neoneon',
        'Paralines',
        'PoiretOne',
        'Prince',
        // 'SEGOESC',
        'Snow',
        'Waxe',
      ],
    };
  },
  watch: {
    object: {
      handler(val) {
        if (!val) return;
        this.activeText = val.text;
        this.activeFontFamily = val.fontFamily;
        // debugger;
        // this.charSpacing = val.charSpacing;
      },
      deep: true,
      immediate: true,
    },
    activeText(val) {
      this.$emit('textChange', { val, id: this.object.id });
    },
    activeFontFamily(val) {
      this.$emit('fontFamilyChange', { val, id: this.object.id });
    },
    // charSpacing(val) {
    //   this.$emit('fontCharSpacingChange', val);
    // },
  },
  methods: {
    handleSetColor(val) {
      // console.log(val);
      this.aciveColor = val;
      this.$emit('fontColorChange', { val, id: this.object.id });
    },

    handleRemove() {
      this.$emit('handleRemove', this.object.id);
    },
  },
};
</script>

<style lang="less">
.font_load_container {
  width: 0.1px;
  height: 0.1px;
  overflow: hidden;
  opacity: 0;
}
.removeIcon {
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  i {
    color: #999;
  }
}
.removeIcon:hover {
  i {
    color: #333;
  }
}
.borad_con_s {
  display: flex;
  justify-content: space-between;
  width: 100%;
  .item {
    margin-right: 10px;
    width: 50%;
    .el-select {
      width: 100%;
    }
    b {
      display: block;
      margin-bottom: 5px;
    }
  }
}
</style>
